/*--

  New logic for adding to the cart use Liquid Ajax Cart
  
  Louis-Charles Blais [info@22agencecreative.ca]
  
--*/

let addToCartButtons = document.querySelectorAll('.product-form__submit');
function startLoadingState() {
  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].setAttribute('disabled', true);
    addToCartButtons[i].classList.add('loading');
  }
}
function stopLoadingState() {
  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].removeAttribute('disabled');
    addToCartButtons[i].classList.remove('loading');
  }
}

document.addEventListener("liquid-ajax-cart:request-start", function(event) {
  startLoadingState();
});
document.addEventListener("liquid-ajax-cart:request-end", function(event) {
  stopLoadingState();
});

document.addEventListener("liquid-ajax-cart:request-start", function(event) {

  /* Get the request body */
  let requestType = event.detail.requestState.requestType;
  
  if (requestType == 'add') {
    let requestBody = Object.fromEntries(event.detail.requestState.requestBody);

    /* Check if the product has gifts */
    if (requestBody.gifts) {
      let gifts = requestBody.gifts.split(",");

      addGifts(gifts, requestBody.quantity, requestBody["id"]);
    }

    /* Wait a bit and open the cart drawer */
    setTimeout(() => {
      if (!cartDrawer.classList.contains('active')) {
        toggleCartDrawer();
      }
    }, 500);

    
  }
  
});

function addGifts(gifts, quantity, bindTo) {
  let body = {};
  body.items = [];
  for (let i = 0; i < gifts.length; i++) {
    let giftId;
    if (gifts[i].includes(':')) {
      giftId = gifts[i].split(':')[0];
    } else {
      giftId = gifts[i];
    };
    body.items[i] = {
      id: giftId,
      quantity: quantity,
      properties: {
        'giftOf': bindTo
      }
    };
    if (gifts[i].includes(':')) {
      body.items[i].properties[gifts[i].split(':')[1].split('=')[0]] = gifts[i].split(':')[1].split('=')[1];
    }
  };
  
  liquidAjaxCart.add(body);
}